import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import buttonBradesco from "../../assets/bradesco/button-bradesco.svg";
import buttonApple from "../../assets/button-apple.svg";
import buttonAndroid from "../../assets/button-android.svg";
import { ContentInfo, ContentText, HomeContainer } from "./style";

export function Home() {
  const userAgent = navigator.userAgent;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);

  const product =
    process.env.REACT_APP_BRADESCO_ID === "true" ? "Bradesco iD" : "SOU iD";

  return (
    <HomeContainer>
      <section>
        <ContentText>
          <h1>Demonstração {product}</h1>
          <p>
            Baixe o aplicativo <strong>{product}</strong> em seu smartphone.
          </p>
          {!isMobile ? (
            <p>
              Use o app para <strong>ler o QR Code</strong> ao lado e receba as
              ofertas das <br /> credenciais.
            </p>
          ) : (
            <p>Use o app para receber as ofertas das credenciais.</p>
          )}

          <p>
            Com as credenciais no <strong>{product}</strong> inicie a
            demonstração e siga os <br /> passos:
          </p>
          <ul>
            <li>
              <span>1</span> Adicione{" "}
              {process.env.REACT_APP_ZKP === "true"
                ? "o Vinho Tinto Suave"
                : "a Televisão OLED"}{" "}
              ao seu carrinho
            </li>
            <li>
              <span>2</span> Clique no carrinho e com o item adicionado
            </li>
            <li>
              <span>3</span> Leia o QR Code para finalizar a compra com o{" "}
              {product}
            </li>
            <li>
              <span>4</span> Após processar seus dados sua compra estará
              finalizada!
            </li>
          </ul>
          <div className="box arrow-right">
            {!isMobile ? (
              <p className="textFooter">
                Ao ler o QR Code, você visualizará a primeira oferta de
                credencial. As demais <br /> credenciais estarão na{" "}
                <strong>home</strong> como <strong>notificações</strong>.
              </p>
            ) : (
              <p className="textFooter">
                Clique no botão "Obter credenciais" para visualizar e aceitar as
                credenciais
              </p>
            )}
            <p className="textFooter">
              Na jornada real, as credenciais virão de emissores e em momentos
              distintos.
            </p>
          </div>
        </ContentText>
        <ContentInfo>
          <p>
            Faça o download do <strong>{product}</strong> <br /> em seu
            smartphone:
          </p>
          {process.env.REACT_APP_BRADESCO_ID === "true" ? (
            <a
              href="https://vmmobile.cpqd.com.br/blockchain/bradescoid/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={buttonBradesco} alt="button apple" />
            </a>
          ) : (
            <>
              <a
                href="https://apps.apple.com/br/app/sou-id/id1662648501?l=en"
                target="_blank"
                rel="noreferrer"
              >
                <img src={buttonApple} alt="button apple" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=br.com.cpqd.souid"
                target="_blank"
                rel="noreferrer"
              >
                <img src={buttonAndroid} alt="button android" />
              </a>
            </>
          )}
          {!isMobile ? (
            <QRCodeSVG
              size={250}
              value={process.env.REACT_APP_QRCODE}
              className="qrcode"
            />
          ) : (
            <section className="btnDeepLink">
              <a
                href={process.env.REACT_APP_QRCODE_MOBILE}
                target="_blank"
                rel="noreferrer"
              >
                Obter credenciais
              </a>
            </section>
          )}
          <h4>Credenciais ofertadas:</h4>
          <ul>
            <li>Identidade</li>
            <li>Endereço</li>
            <li>Cartões de Crédito</li>
          </ul>
        </ContentInfo>
      </section>
      <footer>
        <Link to="/products" className="btnInitDemo">
          Iniciar Demonstração
        </Link>
      </footer>
    </HomeContainer>
  );
}
